"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PLANNING_STAGE = exports.COMPONENT = exports.BUSINESS_UNIT = void 0;
var BUSINESS_UNIT = exports.BUSINESS_UNIT = {
  INSPIRATION: 'INSPIRATION',
  // Deprecated: Use MARKETPLACE for marketplace couples
  INVITATIONS: 'INVITATIONS',
  DIGITAL_SAVE_THE_DATE: 'DIGITAL_SAVE_THE_DATE',
  MARKETPLACE: 'MARKETPLACE',
  MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
  // Deprecated: Use MARKETPLACE for marketplace couples
  MARKETPLACE_VENDORS: 'MARKETPLACE_VENDORS',
  REAL_WEDDINGS: 'REAL_WEDDINGS',
  // marketplace product
  REGISTRY: 'REGISTRY',
  WEDDINGS: 'WEDDINGS',
  WEDDING_REGISTRY: 'WEDDING_REGISTRY',
  STORE: 'STORE',
  PHOTOBOOK: 'PHOTOBOOK'
};
var COMPONENT = exports.COMPONENT = {
  DIGITAL_SAVE_THE_DATE: 'DIGITAL_SAVE_THE_DATE',
  CHANGE_THE_DATE: 'CHANGE_THE_DATE',
  DAY_OF_PAPER: 'DAY_OF_PAPER',
  FAVORITE: 'FAVORITE',
  HOLIDAY: 'HOLIDAY',
  WEDDING_SHOWER_INVITATION: 'WEDDING_SHOWER_INVITATION',
  // Similar to Holidays, should not count as an Invitation
  INQUIRY: 'INQUIRY',
  INSPIRATION: 'INSPIRATION',
  // Deprecated: Use MARKETPLACE for marketplace couples
  INVITATIONS: 'INVITATIONS',
  MARKETPLACE: 'MARKETPLACE',
  MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
  // Deprecated: Use MARKETPLACE for marketplace couples
  MARKETPLACE_MATCH: 'MARKETPLACE_MATCH',
  // Deprecated
  MARKETPLACE_QUIZ: 'MARKETPLACE_QUIZ',
  MARKETPLACE_SIGNUP_BOOKED_VENDOR: 'SIGNUP_BOOKED_VENDOR',
  MARKETPLACE_SIGNUP_VALUE_PROP: 'SIGNUP_VALUE_PROP',
  REAL_WEDDINGS: 'REAL_WEDDINGS',
  REGISTRY: 'REGISTRY',
  SAVE_THE_DATE: 'SAVE_THE_DATE',
  THANK_YOU_CARDS: 'THANK_YOU_CARDS',
  WEDDINGS: 'WEDDINGS',
  WEDDING_CHECKLIST: 'WEDDING_CHECKLIST',
  WEDDING_GUEST_LIST: 'WEDDING_GUEST_LIST',
  WEDDING_PLANNING: 'WEDDING_PLANNING',
  WEDDING_WEBSITE: 'WEDDING_WEBSITE',
  // For marketplace vendors
  BANDS_DJS: 'BANDS_DJS',
  CAKES_DESSERTS: 'CAKES_DESSERTS',
  CATERING: 'CATERING',
  FLORIST: 'FLORIST',
  HAIR_MAKEUP: 'HAIR_MAKEUP',
  PHOTOGRAPHER: 'PHOTOGRAPHER',
  VENUE: 'VENUE',
  VIDEOGRAPHER: 'VIDEOGRAPHER',
  STORE: 'STORE',
  LOCATION_MODULE: 'LOCATION_MODULE',
  QUIZLET: 'QUIZLET',
  STYLE_QUIZ: 'STYLE_QUIZ',
  SIGNUP_SAVED_SEARCH: 'SIGNUP_SAVED_SEARCH',
  VENDOR_MARKETPLACE: 'VENDOR_MARKETPLACE',
  VENDOR_EXPERIENCE: 'VENDOR_EXPERIENCE'
};
var PLANNING_STAGE = exports.PLANNING_STAGE = /*#__PURE__*/function (PLANNING_STAGE) {
  PLANNING_STAGE["NOT_ENGAGED"] = "NOT_ENGAGED";
  PLANNING_STAGE["NEWLY_ENGAGED"] = "NEWLY_ENGAGED";
  PLANNING_STAGE["PLANNING_NO_VENUE_BOOKED"] = "PLANNING_NO_VENUE_BOOKED";
  PLANNING_STAGE["PLANNING_VENUE_BOOKED"] = "PLANNING_VENUE_BOOKED";
  PLANNING_STAGE["ALMOST_DONE"] = "ALMOST_DONE";
  return PLANNING_STAGE;
}({});
var _default = exports.default = {
  BUSINESS_UNIT: BUSINESS_UNIT,
  COMPONENT: COMPONENT,
  PLANNING_STAGE: PLANNING_STAGE
};